/**
 * Base Buddy Fluent UI values: the brand ramp and every theme token that differs
 * between brands. Shared structure: apps/wappbb/frontend/src/theme/fluentTheme.ts
 */

import type { BrandFluent } from "../types";

export const fluent: BrandFluent = {
    brandColors: {
        10: "#060a14",
        20: "#0a1220",
        30: "#0d1520", // --theme-Darker
        40: "#12192e",
        50: "#1a2535", // --theme-Dark
        60: "#152040", // --theme-DarkAlt
        70: "#162a6e",
        80: "#1944c2", // --theme-Primary
        90: "#2652d1",
        100: "#3360e0", // --theme-Secondary
        110: "#4a7aff",
        120: "#6b94ff",
        130: "#7ba4ff", // --theme-Tertiary
        140: "#b3cbff", // --theme-Light
        150: "#dce8ff", // --theme-Lighter
        160: "#f0f4ff" // --theme-LighterAlt
    },
    fonts: {
        fontFamilyBase: '"Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        fontFamilyNumeric: '"Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
    },
    light: {
        colorNeutralBackground2: "#f0f4f9", // --neutral-LighterAlt
        colorNeutralBackground3: "#e2e8f0", // --neutral-Lighter
        colorNeutralBackground4: "#c0cad8", // --neutral-Light
        colorNeutralForeground1: "#1a2535", // --neutral-Primary
        colorNeutralForeground2: "#4a5568", // --neutral-SecondaryAlt
        colorNeutralForeground3: "#a0aab8", // --neutral-QuaternaryAlt
        colorNeutralForegroundDisabled: "#8a95a5", // --neutral-Quaternary
        colorBrandForeground1: "#1944c2", // --theme-Primary
        colorBrandForeground2: "#3360e0", // --theme-Secondary
        colorBrandForegroundLink: "#1944c2",
        colorBrandForegroundLinkHover: "#152040",
        colorBrandForegroundLinkPressed: "#1a2535",
        colorBrandBackground: "#1944c2",
        colorBrandBackgroundHover: "#152040",
        colorBrandBackgroundPressed: "#1a2535",
        colorBrandBackgroundSelected: "#3360e0",
        colorSubtleBackgroundHover: "#dce8ff", // --theme-Lighter
        colorSubtleBackgroundPressed: "#b3cbff", // --theme-Light
        colorSubtleBackgroundSelected: "#dce8ff",
        colorNeutralStroke1: "#e2e8f0", // --neutral-Lighter
        colorNeutralStroke2: "#c0cad8", // --neutral-Light
        colorBrandStroke1: "#1944c2",
        colorBrandStroke2: "#3360e0",
        shadow2: "0px 1px 2px rgba(0, 0, 0, 0.06)",
        shadow4: "0px 2px 4px rgba(0, 0, 0, 0.08)",
        shadow8: "0px 4px 8px rgba(0, 0, 0, 0.08)",
        shadow16: "0px 8px 16px rgba(0, 0, 0, 0.10)",
        shadow28: "0px 14px 28px rgba(0, 0, 0, 0.12)"
    },
    dark: {
        colorNeutralBackground1: "#0f1720", // --neutral-White (dark)
        colorNeutralBackground2: "#141e2e", // --neutral-LighterAlt (dark)
        colorNeutralBackground3: "#1e2d42", // --neutral-Lighter (dark)
        colorNeutralBackground4: "#2a3a50", // --neutral-Light (dark)
        colorNeutralBackgroundStatic: "#0f1720",
        colorSubtleBackgroundHover: "#1e2d42",
        colorSubtleBackgroundPressed: "#141e2e",
        colorSubtleBackgroundSelected: "#3360e0",
        colorSubtleBackgroundLightAlphaHover: "rgba(30, 45, 66, 0.7)",
        colorSubtleBackgroundLightAlphaPressed: "rgba(20, 30, 46, 0.9)",
        colorNeutralForeground1: "#f0f4f9", // --neutral-LighterAlt
        colorNeutralForeground2: "#e2e8f0", // --neutral-Lighter
        colorNeutralForeground3: "#a0aab8", // --neutral-QuaternaryAlt
        colorNeutralForeground4: "#718096", // --neutral-TertiaryAlt
        colorNeutralForegroundDisabled: "#4a5568", // --neutral-SecondaryAlt
        colorBrandForeground1: "#4a7aff",
        colorBrandForeground2: "#6b94ff",
        colorBrandForegroundLink: "#6b94ff",
        colorBrandForegroundLinkHover: "#99b8ff",
        colorBrandForegroundLinkPressed: "#b3cbff",
        colorBrandBackground: "#1944c2",
        colorBrandBackgroundHover: "#152040",
        colorBrandBackgroundPressed: "#1a2535",
        colorBrandBackgroundSelected: "#3360e0",
        colorNeutralStroke2: "#2a3a50",
        colorNeutralStroke3: "#374a60",
        colorBrandStroke1: "#4a7aff",
        colorBrandStroke2: "#6b94ff",
        shadow2: "0px 1px 2px rgba(0, 0, 0, 0.16)",
        shadow4: "0px 2px 4px rgba(0, 0, 0, 0.20)",
        shadow8: "0px 4px 8px rgba(0, 0, 0, 0.20)",
        shadow16: "0px 8px 16px rgba(0, 0, 0, 0.20)",
        shadow28: "-2px -9px 18.1px 0px rgba(0, 0, 0, 0.30)"
    }
};
